import { queuePartition } from './api'
import { addDaysISO, todayISO } from './ui'

// A visit that couldn't be done, moved to another day (Liam, 22 Oct 2026: "Couldnt yaschica because of job before
// whats the rearaange flow i dont see it?"; docs/plans/rearrange/PLAN.md). The pure half: which days the move offers,
// and the moves whose customer has not been told yet, kept on this phone until they are.

// Six days from tomorrow; a visit from a day already gone can go today too (booking-days.ts DAY_CHIPS' six).
export const MOVE_DAYS = 6
export function moveDays(visitDate: string, today: string = todayISO()): string[] {
  const first = visitDate < today ? today : addDaysISO(today, 1)
  return Array.from({ length: MOVE_DAYS }, (_, i) => addDaysISO(first, i))
}

// "Not told yet": a move made from Today whose message was put away, or could not open (no signal). One per moved visit,
// shown at the top of Today with Message and "I told them", until sent, told, undone, or the new day has gone.
export interface ToTell {
  visitId: number
  customerId: number
  name: string
  from: string // the day it couldn't be done
  to: string // the day it was moved to
  reason: string | null // ui.ts blockedChoiceOf: 'time' for Ran out of time
  jobIds: (number | null)[] // the jobs moved together (the house's visits on that day)
  on: string // when the move was made
}

const STORE = 'roundly:missed-to-tell'
function storeKey(): string | null {
  const ns = queuePartition()
  return ns === null ? null : `${STORE}:${ns}`
}
export function toTellList(today: string = todayISO()): ToTell[] {
  const k = storeKey()
  if (k === null) return []
  try {
    const list = JSON.parse(localStorage.getItem(k) ?? '[]') as ToTell[]
    return Array.isArray(list) ? list.filter((t) => t && typeof t.visitId === 'number' && t.to >= today) : []
  } catch {
    return []
  }
}
function writeList(list: ToTell[]): void {
  const k = storeKey()
  if (k === null) return
  try {
    if (list.length) localStorage.setItem(k, JSON.stringify(list))
    else localStorage.removeItem(k)
  } catch {
    // storage off: the row is not kept, and Messages still lists them by its own rules
  }
}
export function keepToTell(t: ToTell): void {
  writeList([...toTellList().filter((x) => x.visitId !== t.visitId), t])
}
export function forgetToTell(visitId: number): void {
  const list = toTellList()
  if (list.some((t) => t.visitId === visitId)) writeList(list.filter((t) => t.visitId !== visitId))
}
